// import request from './http';
import { getParameter } from "@/utils/global";
let loginStyle = getParameter('loginStyle');
const guestId = getParameter('guestId');
import { post, getJson } from '@/api/http';

/** 心跳作用防止登录之后token过期 */
// export const heartbeat = (data) => {
//   return request({
//     url: '/monitor/v1/heartbeat',
//     method: 'POST',
//     data: data,
//   });
// };
// post(`${config.cppm}user/v1/heartbeat`, { token: data }, { token: data });
export const heartbeat = (data) =>
post(`${config.cppm}user/v1/heartbeat`, { token: data }, { token: data }, {
  timeout: 30000
});
// export const userRefresh = (params) => {
//   return request({
//     url: '/monitor/v1/webcast/user/refresh',
//     method: 'get',
//     params,
//   });
// };
export const userRefresh = (data, token) =>
  getJson(`${config.cpp}monitor/${loginStyle}/webcast/user/refresh`, data, { token });
// export const userLogin = (data) => {
//   console.log(request.default, 'requestrequest');
//   return request({
//     url: '/monitor/v1/login',
//     method: 'POST',
//     data: data,
//   });
// };

export const userLogin = (data) => post(`${config.cppm}monitor/${loginStyle}/live_login`, data);

// 获取用户信息
export const userInfo = (webcastId, token) => post(`${config.cpp}monitor/v2/login/info/${webcastId}`, null, { token })

//获取指定嘉宾信息
export const guestUserInfo = (specialGuestId) => getJson(`${config.cppm}monitor/${loginStyle}/webcast/user/special_guest_name/${specialGuestId} `, null)
//指定嘉宾是否重复
export const specialGuestInfo = (webcastId, userId) => getJson(`${config.cppm}monitor/${loginStyle}/webcast/user/${webcastId}/${userId}`, null)

export const AnchorStatus = (data, token) => post(`${config.cpp}monitor/v2/webcast/user/host`, data, { token })

// 验证密码
export const pwdCheck = (webcastId, passCode) => post(`${config.cpp}monitor/v2/login/pwd_check`, {
  "checkCode": "",
  "liveType": 1,
  "passCode": passCode,
  "phoneNumber": "",
  "smsCode": "",
  "type": 11,
  "webcastId": webcastId,
  "specialGuestId": guestId
})

// 验证坐标
export const verifySlider = (webcastid, uuid, x) => getJson(`${config.cpp}monitor/v2/login/verify/${webcastid}/${uuid}/${x}`, {})

// 获取验证码图片
export const getVerifyImage = () => getJson(`${config.cpp}monitor/v2/login/verify_code`, {})

export const pushStreamUrl = (webcastId,token) => getJson(`${config.cpp}monitor/v1/webcast/${webcastId}/pushstream/url`,null,{token})
// 获取电话连线信息接口

export const getPhoneConnectInfo = (token) => getJson(`${config.cpp}monitor/v2/webcast/phone_connect`,null,{token})

// 获取合同相关配置
export const getContract = (webcastId) => getJson(`${config.cpp}monitor/v2/contract/${webcastId}`)

// 品牌隐藏
export const getHiddenBrandStatus = (cid) => getJson(`${config.cpp}monitor/v2/webcast/cloud-setting/${cid}`)

// 获取第三方登录信息

export const getDisposableLogin = (token) => getJson(`${config.cpp}monitor/v2/login/disposable_login/${token}`)


//查询直播间-主播相关设置

export const hostSetting = (webcastId, token) => getJson(`${config.cpp}monitor/v2/webcast/${webcastId}/host/setting`,null,{token})

//获取是否开启视频审核
export const otherSetting = (webcastId, token) => getJson(`${config.cpp}monitor/v2/webcast/getOtherSetting/${webcastId}`,null,{token})